import React from "react";
import ModalWrapper from "./ModalWrapper";
import { UilSearch } from "@iconscout/react-unicons";
import useSWR from "swr";
import Spinner from "./Spinner";
import { useFormContext, useWatch } from "react-hook-form";

export default function LanguageModal({ name = "language", onClos, error, label = "Language" }) {
  const { setValue } = useFormContext();
  const query = useWatch({ name: `${name}Search` }) || "";
  const { data, isValidating } = useSWR('/entertainment/movie-box/languages');

  const allLanguages = data?.data;
  const filtered = query
    ? allLanguages?.filter((lang) =>
        lang?.name?.toLowerCase().includes(query.toLowerCase())
      )
    : allLanguages;

  // Add state to control modal open/close
  const [open, setOpen] = React.useState(false);
  const { getValues } = useFormContext();
  const selectedId = getValues(name);
  const selectedLang = allLanguages?.find(l => l.id === selectedId);

  return (
    <>
 <div>
       {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
       <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center justify-between w-full p-3 bg-white border rounded-md text-left text-sm mb-2"
      >
        <span>{selectedLang?.name || "Select language"}</span>
        <UilSearch className="h-4 w-4 text-gray-500" />
      </button>
      {error && <p className="text-red-500 text-sm">{error}</p>}
 </div>
      {open && (
        <ModalWrapper title={'Select language'} onClose={() => setOpen(false)}>
          {isValidating ? (
            <Spinner />
          ) : (
            <>
              <div className="flex items-center border rounded-md px-2 py-1 mb-4 bg-blue-50">
                <UilSearch className="text-gray-500 w-4 h-4 mr-2" />
                <input
                  type="text"
                  placeholder="Search language..."
                  value={query}
                  onChange={(e) => setValue(`${name}Search`, e.target.value)}
                  className="flex-1 bg-transparent outline-none text-sm"
                />
              </div>

              <div className="overflow-y-scroll h-[300px]">
                <ul className="space-y-1">
                  {filtered?.map((lang) => (
                    <li key={lang?.id}>
                      <button
                        type="button"
                        onClick={() => {
                          setValue(name, lang?.id);
                          setOpen(false);
                        }}
                        className={`w-full text-left px-3 py-2 border-b rounded hover:bg-blue-50 ${
                          lang?.id === selectedId
                            ? "bg-blue-100 font-semibold text-blue-700"
                            : ""
                        }`}
                      >
                        {lang?.name}
                        {lang?.id === selectedId && (
                          <span className="ml-2 text-xs text-blue-700">(Selected)</span>
                        )}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </ModalWrapper>
      )}
    </>
  );
}
